import type { Content } from '@gra/content';
import { equippedItems, itemPower, type Profile } from './profile';

/** Moc ekwipunku: suma mocy założonych przedmiotów aktualnej klasy. */
export function equipmentPower(content: Content, profile: Profile): number {
  return equippedItems(content, profile).reduce((sum, { inst }) => sum + itemPower(content, inst), 0);
}
